import { NgModule, ModuleWithProviders } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UserHttpService } from "./user-http.service";
import { UserService } from "./user.service";
import { ComponentsModule } from '../../components/components.module';
import { TranslateModule } from '@ngx-translate/core';
import { AuthenticationService } from '../../core/authentication/authentication.service';
import { ErrorService } from '../../core/error/error.service';

let userService: UserService;

@NgModule({
  imports: [
    IonicPageModule,
    ComponentsModule,
    TranslateModule.forChild(),
  ],
  providers: [
    UserHttpService,
    UserService
  ]
})
export class UserModule {
  public static forRoot() : ModuleWithProviders {
    return {
      ngModule: UserModule,
      providers: [
        UserHttpService,
        {
          provide: UserService,
          useFactory: (
            userHttp: UserHttpService,
            authService: AuthenticationService,
            errorService: ErrorService
          ) => {
            if(!userService) {
              userService = new UserService(userHttp, authService, errorService);
            }
            return userService;
          },
          deps: [UserHttpService, AuthenticationService, ErrorService]
        }
      ]
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/services/user/user.module.ts